module.exports = __webpack_public_path__ + "static/weight-477c35146020b19064e10f2a89e92922.svg";